export const JobPositionEN = {
    "jobPosition": {
        "title": {
            "header": "Job position",
            "add": "Create a new job position",
            "update": "Update job position"

        },
        "columns": {
            "id": "ID",
            "name": "Name",
            "order": "Order",
            "jobTitleName": "Job Title Name",
            "salaryMax": "Salary max",
            "salaryMin": "Salary min",
        }
    }
}